import React from 'react';
import { Container, Box, Typography } from '@mui/material';

/**
 * Static About page for TITLE company mission and overview.
 */
const AboutCompany: React.FC = () => (
  <Container maxWidth="md" sx={{ py: 4 }}>
    {/* Company image above the about text; place the image at public/images/about-company.jpg */}
    <Box
      component="img"
      src="/media/about.jpg"
      alt="About TITLE"
      sx={{
        width: '100%',
        height: 'auto',
        mb: 2,
      }}
    />
    <Box
      component="div"
      sx={{
        textAlign: 'justify',
        '& p': (theme) => ({ ...theme.typography.body1, mb: 2 }),
      }}
    >
      <Typography paragraph>
        We’re a San Francisco–based music personalization company on a mission to make music more personal, more open, and more fair.
      </Typography>
      <Typography paragraph>
        Unlike apps that just recommend tracks from a catalog, TITLE personalizes your favorite songs. We organize music by title — the song itself — and gather every version in one place, from the iconic original to the boldest covers and reinterpretations.
      </Typography>
      <Typography paragraph>
        For listeners, that means rediscovering songs you love in fresh ways, while effortlessly uncovering artists you might never have found on your own. For artists, it means being heard — right alongside the songs and audiences they deserve.
      </Typography>
      <Typography paragraph>
        With TITLE, discovery feels simple, joyful, and human. Instead of sifting through endless playlists, you experience the music you care about most — sung, played, and reimagined by voices both familiar and new.
      </Typography>
    </Box>
    {/* Signature block below the about text */}
    <Box sx={{ mt: 4 }}>
      <Typography>Vitaliy Kulikov,</Typography>
      <Typography>Founder</Typography>
      <Typography>September 15, 2025</Typography>
    </Box>
  </Container>
);

export default AboutCompany;